<template>
  <Form
    ref="details"
    :model="fromData"
    :rules="ruleValidate"
    label-position="right"
    :label-width="120"
  >
    <Row span="24">
      <Col span="10">
        <FormItem :label="$t('add.city.415013-0')" prop="ProvinceCode">
          <Select
            v-model="fromData.ProvinceCode"
            :placeholder="$t('add.city.415013-1')"
            @on-change="changeProvince"
          >
            <Option
              v-for="(item, index) in provinceArr"
              :key="item.id"
              :value="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </FormItem>
      </Col>
      <Col span="10">
        <FormItem :label="$t('add.city.415013-2')" prop="CityCode">
          <Select v-model="fromData.CityCode" :placeholder="$t('add.city.415013-3')">
            <Option
              v-for="(item, index) in citiesArr"
              :key="item.id"
              :value="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </FormItem>
      </Col>
      <Col span="10">
        <FormItem :label="$t('add.city.415013-4')" prop="Cname">
          <Input v-model="fromData.Cname" :placeholder="$t('add.city.415013-5')"></Input>
        </FormItem>
      </Col>
    </Row>
  </Form>
</template>

<script>
import provinces from "../../../../../api/provinces.js";
export default {
    props: {
        row: {
            type: Object,
            default: () => {}
        }
    },
  data() {
    return {
      provinceArr: provinces(), // 添加区域所需信息
      citiesArr: [],
      fromData: {
        ProvinceCode: "",
        ProvinceName: "",
        CityCode: "",
        CityName: "",
        Cname: "",
        Address: '',
        Jd: '120.25537447004918',
        Wd: '30.322760843944423',
      },
      ruleValidate: {
        ProvinceCode: [{ required: true, message: this.$t('add.city.415013-6'), trigger: "change" }],
        CityCode: [{ required: true, message: this.$t('add.city.415013-3'), trigger: "change" }],
        Cname: [{ required: true, message: this.$t('add.city.415013-5'), trigger: "blur" }]
      }
    };
  },
  methods: {
    // 实现省市区联动
    changeProvince(val) {
      this.provinceArr.forEach(item => {
        if (val == item.id) {
          this.citiesArr = item.child;
          this.fromData.CityCode = "";
        }
      });
    },
    async submit() {
      const from = { ...this.fromData };
      await this.$refs.details.validate();
      from.ProvinceName = this.provinceArr.find(
        item => item.id === from.ProvinceCode
      ).name;
      from.CityName = this.citiesArr.find(item => item.id === from.CityCode).name;
      from.Address = from.CityName
      return from;
    },
    setData(data) {
        if (data.ProvinceCode) {
            this.changeProvince(data.ProvinceCode)
            this.$nextTick(() => {
                this.fromData = { ...data }
            })
        }
    },
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/useGas/views/area/add/city.vue